module.exports = __webpack_public_path__ + "img/scene-3.34ecea2.png";